/* __next_internal_client_entry_do_not_use__ default auto */ import useForkRef from "../useForkRef/index.js";
import appendOwnerState from "../appendOwnerState/index.js";
import mergeSlotProps from "../mergeSlotProps/index.js";
import resolveComponentProps from "../resolveComponentProps/index.js";
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function useSlotProps(parameters) {
    var _parameters_additionalProps;
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = mergeSlotProps({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = useForkRef(internalRef, resolvedComponentsProps === null || resolvedComponentsProps === void 0 ? void 0 : resolvedComponentsProps.ref, (_parameters_additionalProps = parameters.additionalProps) === null || _parameters_additionalProps === void 0 ? void 0 : _parameters_additionalProps.ref);
    const props = appendOwnerState(elementType, {
        ...mergedProps,
        ref
    }, ownerState);
    return props;
}
export default useSlotProps;
